import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/multi-tenant/_layout/')({
	beforeLoad: () => {
		throw redirect({ to: '/multi-tenant/cases' })
	},
})
